var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAppleLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.566,
    height: 22.773
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".apple-logo_svg__cls-1{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "apple-logo_svg__apple-logo",
    transform: "translate(-2.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "apple-logo_svg__Group_16290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "apple-logo_svg__Path_10406",
    d: "M15.769 0h.162A4.876 4.876 0 0114.7 3.675a3.807 3.807 0 01-3.351 1.573A4.73 4.73 0 0112.6 1.687 5.4 5.4 0 0115.769 0z",
    className: "apple-logo_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "apple-logo_svg__Path_10407",
    d: "M20.67 16.716v.045a13.25 13.25 0 01-1.9 3.655c-.723 1-1.609 2.334-3.191 2.334-1.367 0-2.275-.879-3.676-.9-1.482-.024-2.3.735-3.652.926h-.458a4.126 4.126 0 01-2.383-1.645 14.386 14.386 0 01-3.31-8.276v-1.019a6.674 6.674 0 012.918-5.478 4.921 4.921 0 013.3-.765 8.312 8.312 0 011.619.464 4.47 4.47 0 001.618.485 3.884 3.884 0 001.139-.342 6.984 6.984 0 013.652-.648 5.067 5.067 0 013.723 2.22 4.778 4.778 0 00-2.427 4.74 4.893 4.893 0 003.028 4.204z",
    className: "apple-logo_svg__cls-1"
  })))));
}

export default SvgAppleLogo;